"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dragEventHasFile = void 0;
var dragEventHasFile = function (event) { var _a, _b; return !!((_b = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types) === null || _b === void 0 ? void 0 : _b.includes("Files")); };
exports.dragEventHasFile = dragEventHasFile;
